module.exports = __webpack_public_path__ + "static/media/filex.12c195b2.png";